import { XMarkIcon } from "@heroicons/react/24/outline";

// Fixed h-*/w-* (not min-h/min-w) so percentage-sized icon content below
// resolves against a definite box — an auto-sized flex item can't satisfy a
// child's `w-2/3 h-2/3`, which otherwise blows up to the SVG's UA default size.
const SIZE_CLASSES = {
    md: "h-11 w-11 sm:h-12 sm:w-12 lg:h-14 lg:w-14",
    sm: "h-5 w-5 sm:h-6 sm:w-6"
};

const describeState = (userState, effectiveDeduced) => {
    if (userState === 'filled') return 'marked filled';
    if (userState === 'crossed') return 'marked crossed';
    if (effectiveDeduced === 'filled') return 'solver-deduced filled';
    if (effectiveDeduced === 'crossed') return 'solver-deduced crossed';
    return 'unknown';
};

// Solid border = the user's own mark; dashed border = the solver's proof —
// filled vs crossed is always read from shape (square vs X), not colour alone.
export const NonogramCell = ({
    index,
    userState = 'unknown',
    deducedState = null,
    interactive = false,
    onClick,
    size = 'md'
}) => {
    const effectiveDeduced = userState === 'unknown' ? deducedState : null;

    let cellClasses = "bg-white border border-gray-300";
    let content = null;

    if (userState === 'filled') {
        cellClasses = "bg-badger-purple border border-badger-purple";
    } else if (userState === 'crossed') {
        cellClasses = "bg-white border border-gray-400";
        content = <XMarkIcon className="w-2/3 h-2/3 text-gray-700" strokeWidth={3} />;
    } else if (effectiveDeduced === 'filled') {
        cellClasses = "bg-badger-purple/15 border-2 border-dashed border-badger-purple";
        content = <span className="block w-1/2 h-1/2 rounded-sm bg-badger-purple" />;
    } else if (effectiveDeduced === 'crossed') {
        cellClasses = "bg-white border-2 border-dashed border-gray-400";
        content = <XMarkIcon className="w-1/2 h-1/2 text-gray-400" strokeWidth={2} />;
    }

    const label = `Cell ${index + 1}: ${describeState(userState, effectiveDeduced)}${interactive ? ', click to mark' : ''}`;
    const baseClasses = `flex items-center justify-center rounded-sm shrink-0 transition-colors ${SIZE_CLASSES[size]} ${cellClasses}`;

    if (!interactive) {
        return (
            <div className={baseClasses} aria-label={label} title={label}>
                {content}
            </div>
        );
    }

    return (
        <button
            type="button"
            onClick={() => onClick(index)}
            className={`${baseClasses} hover:border-badger-purple focus:outline-none focus:ring-2 focus:ring-badger-purple focus:ring-offset-1`}
            aria-label={label}
            title={label}
        >
            {content}
        </button>
    );
};
